import { useContext, useState } from "react";
import PrestacionContext from '../../context/PrestacionesContext/PrestacionContext';
import { openCreateModal } from "../../context/PrestacionesContext/Actions";
import { Grid } from "@material-ui/core";
import { Box } from '@mui/material';
import BodyPrestacion from "./BodyPrestacion";
import AddIcon from "../../assets/svg/icono_agregar_blue.svg";
import Cuadricula from "../../assets/svg/Cuadricula.svg";
import lista from "../../assets/svg/Lista.svg";
import CreateBenefits from "./modals/CreateBenefits";
import UpdateBenefits from "./modals/UpdateBenefits";
import "../Prestaciones/css/Prestaciones.css";
import Loading from '../Loading';
import loadingGif from '../../assets/loading.gif'

const PrestacionContent = () => {

  const { state, dispatch } = useContext(PrestacionContext);
  const [viewMode, setViewMode] = useState<'square' | 'list'>('square');//Usar solo un estado de vista compartido
  const [infoImg, setInfoImg] = useState({});

  const handleViewSquare = () => {
    setViewMode('square');
  }
  const handleViewList = () => {
    setViewMode('list')
  }

  return (
    <>
      <div className="contenedorHead" >
        <Box mt={3} ml={5} className="Title" mb={2}>
          Prestaciones
        </Box>
        <div className="conteinderBtnsPrestaciones">
          <div className={`btnViewMode ${viewMode === 'square' ? 'active' : ''}`}
            onClick={handleViewSquare}
          >
            <img src={Cuadricula} alt="Cuadricula" />
            <span>Cuadrícula</span>
          </div>

          {/* Botón Lista */}
          <div className={`btnViewMode ${viewMode === 'list' ? 'active' : ''}`} onClick={handleViewList} >
            <img src={lista} alt="Lista" />
            <span>Lista</span>
          </div>
          <div>
            <button
              id="addPrestacion"
              onClick={() => openCreateModal(dispatch)}
              className="btnNuevaPrestacion"
            >
              <div className="alineacionBoton">
                <img src={AddIcon} alt="Agregar Prestación" />
                <div className="nombrePrestacion">
                  <b>
                    <span>Nueva Prestación</span>
                  </b>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
      <CreateBenefits
      //setInfoImg={setInfoImg}
      />
      {state._id !== '' &&
        <UpdateBenefits />
      }

      <Grid className="containerBodyPrestacion">
        <BodyPrestacion
          infoImg={infoImg}
          viewSquare={viewMode === 'square'} //Revisa si viewMode es square
          viewList={viewMode === 'list'} ////Revisa si viewMode es list
        />
      </Grid>
      {state.globalLoading && (
        <Loading className="global-loading-overlay">
            {/* Puedes personalizar esto con tu GIF y estilos */}
            <div style={{
                position: 'fixed', 
                top: 0, left: 0, width: '100%', height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.7)', // Fondo blanco semitransparente
                zIndex: 9999, // Por encima de todo (incluso modales)
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column'
            }}>
                <img src={loadingGif} alt="Cargando..." style={{ width: '80px' }} />
                <p style={{ marginTop: '10px', color: '#666', fontWeight: 'bold' }}>Procesando...</p>
            </div>
        </Loading>
      )}
    </>

  )
}

export default PrestacionContent